<div class="test-numbers" *ngIf="layout === 'chips'">
    <div class="test-numbers-lock-note" *ngIf="showLockNote">
        <ng-icon name="heroLockClosed" [strokeWidth]="'1.5'"></ng-icon>
        <span>{{ 'GUIDED_SETUP.TEST_NUMBERS.LOCK_NOTE' | translate }}</span>
    </div>
    <div class="test-numbers-chips">
        <div class="test-number-chip" *ngFor="let phoneNumber of activeNumbers; trackBy: trackByNumber">
            <span class="test-number-chip-label">{{ phoneNumber.number | phoneNumber }}</span>
            <ng-icon class="test-number-chip-remove" name="heroXCircle" role="button" tabindex="0"
                [attr.aria-label]="'GUIDED_SETUP.TEST_NUMBERS.REMOVE_NUMBER' | translate"
                (click)="removeNumber(phoneNumber, $event)" (keydown.enter)="removeNumber(phoneNumber, $event)"></ng-icon>
        </div>
        <div class="test-number-add-row" *ngIf="isAdding && addNumberForm" [formGroup]="addNumberForm">
            <rosie-phone #addPhoneInput [control]="addNumberForm.get('number')" [placeholderTranslationKey]="'(000) 000-0000'"
                class="test-number-add-input"></rosie-phone>
            <rosie-button [customClass]="'slimmer narrow text-sm'" [fullWidth]="false" [translationKey]="'COMMON.SAVE'"
                [customType]="'button'" [disabled]="!canSaveNewNumber" [inProgress]="isSavingNewNumber"
                (click)="saveNewNumber()"></rosie-button>
            <rosie-button [customClass]="'secondary slimmer narrow text-sm'" [fullWidth]="false"
                [translationKey]="'COMMON.CANCEL'" [customType]="'button'" (click)="cancelAdd()"></rosie-button>
        </div>
        <rosie-button *ngIf="!isAdding && canAddMore" [customClass]="'secondary test-number-add-button'"
            [fullWidth]="false" [customType]="'button'" [translationKey]="'GUIDED_SETUP.TEST_NUMBERS.ADD_NUMBER'"
            [iconPrefixConfig]="{name: 'heroPlusMini', size: '20px', color: '#6C6176'}" (click)="startAdd()"></rosie-button>
    </div>
</div>

<ngx-smart-modal *ngIf="layout === 'modal-only'" #testNumbersModal disableRefocus identifier="testNumbersModal"
    [customClass]="'narrower-modal'" (onAnyCloseEventFinished)="handleTestNumbersModalClose()">
    <div class="modal-title">{{ 'GUIDED_SETUP.TEST_NUMBERS.TITLE' | translate }}</div>
    <div class="modal-subtitle with-border">{{ 'GUIDED_SETUP.TEST_NUMBERS.SUBTITLE' | translate }}</div>
    <div class="modal-content">
        <div *ngFor="let control of draftTestNumbersFormArray?.controls; let i = index; let last = last;"
            class="test-number-input-wrapper" [formGroup]="control">
            <div class="phone-input-container" [ngClass]="{'mb-4': !last}">
                <rosie-phone [control]="control.get('number')" [placeholderTranslationKey]="'(000) 000-0000'"
                    class="w-100 d-block">
                </rosie-phone>
                <ng-icon *ngIf="hasTestNumberValue(i)" [name]="'heroXCircle'" class="remove-button"
                    (click)="removeTestNumber(i)" aria-label="Remove test number">
                </ng-icon>
            </div>
        </div>
    </div>

    <div class="modal-action-line with-border">
        <rosie-button (click)="handleTestNumbersModalClose(); testNumbersModal.close()" class="d-block"
            [customClass]="'secondary narrow'" [translationKey]="'COMMON.CANCEL'">
        </rosie-button>
        <rosie-button (click)="saveTestNumbers()" class="d-block" [customClass]="'narrow slim'"
            [translationKey]="'COMMON.SAVE'">
        </rosie-button>
    </div>
</ngx-smart-modal>
